import { FieldsToShow, FieldToShow } from '@phx-husky/auth-service';

export const getLegalsField = (legalField: FieldToShow): FieldsToShow => {
  const defaultValue = legalField?.options
    ?.filter((item) => item.isRequired)
    .map((item) => item.key);

  const options = legalField.options
    ? legalField.options.map((option) => ({
        ...option,
        isDisabled: option.isRequired,
      }))
    : [];

  return { legals: { ...legalField, defaultValue, options } };
};

export const filterFields = (
  fields: Record<string, FieldToShow | undefined>,
  keys: Array<string>
): Record<string, FieldToShow> =>
  Object.keys(fields).reduce<Record<string, FieldToShow>>((acc, key) => {
    if (keys.includes(key) && fields[key] !== undefined) {
      return { ...acc, [key]: fields[key]! };
    }

    return acc;
  }, {});
